const dev = process.env.NODE_ENV === "development";
// const dev = false;

export const GATSBY_URL = dev
  ? "http://localhost:8000"
  : "https://theneweraofhealth.com";

export const API_URL = dev
  ? "http://localhost:3001"
  : "https://server.theneweraofhealth.com";

export const SHOPIFY_URL = dev
  ? "https://the-new-era-of-health.myshopify.com"
  : "https://store.theneweraofhealth.com";
